import { CloseSquare } from "iconsax-react";

export const DateFilterModal = ({
  isOpen,
  onClose,
  onApply,
  dateRange,
  setDateRange,
}) => {
  if (!isOpen) return null;

  const handleApply = () => {
    onApply();
    onClose();
  };

  const handleClear = () => {
    setDateRange({ startDate: "", endDate: "" });
    onApply({ startDate: "", endDate: "" });
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-40" onClick={onClose}></div>

      <div className="fixed min-w-[400px] max-w-[500px] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-50 bg-white rounded-md shadow-lg">
        <div className="px-5 pt-4 flex justify-between items-center rounded-t-md">
          <div className="text-[15px] font-medium select-none">
            <h2>Filter by Date</h2>
          </div>
          <button onClick={onClose}>
            <CloseSquare variant="Bold" size={24} />
          </button>
        </div>

        <div className="px-5 py-6 space-y-4">
          <div>
            <label className="block text-[14px] font-medium text-gray-700 mb-1">
              Start Date
            </label>
            <input
              type="date"
              value={dateRange.startDate}
              onChange={(e) =>
                setDateRange({ ...dateRange, startDate: e.target.value })
              }
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-[14px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-[14px] font-medium text-gray-700 mb-1">
              End Date
            </label>
            <input
              type="date"
              value={dateRange.endDate}
              onChange={(e) =>
                setDateRange({ ...dateRange, endDate: e.target.value })
              }
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-[14px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>

          {dateRange.startDate && dateRange.endDate && (
            <div className="text-[13px] text-gray-600 bg-gray-50 p-3 rounded-md">
              <p>
                Filtering from{" "}
                <span className="font-medium">
                  {new Date(dateRange.startDate).toLocaleDateString()}
                </span>{" "}
                to{" "}
                <span className="font-medium">
                  {new Date(dateRange.endDate).toLocaleDateString()}
                </span>
              </p>
            </div>
          )}
        </div>

        <div className="flex justify-between px-5 pb-4 rounded-b-md">
          <button
            className="px-4 py-2 text-[14px] font-medium text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-50"
            onClick={handleClear}
          >
            Clear Filter
          </button>
          <div className="flex gap-3">
            <button
              className="px-4 py-2 text-[14px] font-medium text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-50"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-[14px] font-medium text-white bg-primary rounded-full hover:opacity-80"
              onClick={handleApply}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
